import React, { useState, useEffect } from "react";
import { Container, Row, Col, Breadcrumb, Card } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Divider,message } from "antd";

import {
  HomeOutlined,
  EditOutlined,
  DeleteOutlined,
  FileOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Select,
  Upload,
  Space,
  Card as AntCard,
} from "antd";
import dayjs from "dayjs";
import api from "@/api/api";
import { getEventDetailWithStatus, updateEvent } from "@/api/eventApi";
import "./EventCreate.css"; // reuse same style

const { TextArea } = Input;

const EventEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [initialEvent, setInitialEvent] = useState(null);

  useEffect(() => {
    fetchUsers();
    fetchEventDetail();
  }, [id]);

  // 🔹 1. Foydalanuvchilarni olish
  const fetchUsers = async () => {
    try {
      const response = await api.get("/tasks/users");
      if (response.data.success) {
        setUsers(response.data.data || []);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
      message.error("Foydalanuvchilarni yuklashda xatolik");
    }
  };

  // 🔹 2. Mavjud eventni yuklash
  const fetchEventDetail = async () => {
    setLoading(true);
    try {
      const data = await getEventDetailWithStatus(id);
      setInitialEvent(data);

      if (!data) return;
      // Formani to‘ldirish
      form.setFieldsValue({
        name: data.name,
        datetime: dayjs(data.datetime),
        tasks:
          data.tasks?.map((task) => ({
            title: task.title,
            description: task.description,
            user_ids: task.assigned_users?.map((u) => u.id) || [],
          })) || [],
      });

      // Fayl mavjud bo‘lsa
      if (data.file) {
        setFileList([
          {
            uid: "-1",
            name: data.file.split("/").pop(),
            status: "done",
            url: data.file,
          },
        ]);
      }
    } catch (err) {
      message.error("Event ma'lumotlarini yuklashda xatolik");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 3. Faylni boshqarish
  const handleFileChange = ({ fileList: newList }) => {
    setFileList(newList.slice(-1)); // faqat 1 fayl
  };

  const beforeUpload = (file) => {
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("Fayl hajmi 10MB dan kichik bo'lishi kerak!");
      return false;
    }
    return false; // avtomatik upload emas
  };

  // 🔹 4. Formani yuborish
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const eventData = {
        name: values.name,
        datetime: values.datetime.toISOString(),
        tasks: values.tasks || [],
      };

      // Agar yangi fayl tanlangan bo‘lsa
      if (fileList.length > 0 && fileList[0].originFileObj) {
        eventData.file = fileList[0].originFileObj;
      }

      await updateEvent(id, eventData);
      message.success("Event muvaffaqiyatli yangilandi!");
      navigate(`/events/detail/${id}`);
    } catch (err) {
      console.error("Error updating event:", err);
      message.error(err.response?.data?.message || "Event yangilashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="p-4">
      {/* Breadcrumb */}
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/events/all" }}>
          Barcha eventlar
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Tahrirlash</Breadcrumb.Item>
      </Breadcrumb>

      <h2 className="mb-4 mt-3">
        <EditOutlined className="me-2" />
        Eventni tahrirlash
      </h2>

      <Row>
        <Col xs={12} lg={8}>
          <Card>
            <Card.Body>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                  tasks: [{ title: "", description: "", user_ids: [] }],
                }}
              >
                {/* Event Name */}
                <Form.Item
                  label="Event nomi"
                  name="name"
                  rules={[{ required: true, message: "Event nomini kiriting!" }]}
                >
                  <Input size="large" placeholder="Masalan: Yillik yig'ilish" />
                </Form.Item>

                {/* Event DateTime */}
                <Form.Item
                  label="Sana va vaqt"
                  name="datetime"
                  rules={[{ required: true, message: "Sana va vaqtni tanlang!" }]}
                >
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm"
                    size="large"
                    style={{ width: "100%" }}
                    placeholder="Sana va vaqtni tanlang"
                  />
                </Form.Item>

                {/* File Upload */}
                <Form.Item label="Fayl biriktirish (ixtiyoriy)">
                  <Upload
                    fileList={fileList}
                    onChange={handleFileChange}
                    beforeUpload={beforeUpload}
                    maxCount={1}
                    listType="text"
                  >
                    <Button icon={<FileOutlined />}>Fayl tanlash</Button>
                  </Upload>
                  <small className="text-muted">Maksimal hajm: 10MB</small>
                </Form.Item>

                <Divider />

                {/* Tasks */}
                <h5 className="mb-3">Topshiriqlar</h5>

                <Form.List name="tasks">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <AntCard
                          key={key}
                          className="mb-3"
                          title={`Topshiriq ${index + 1}`}
                          extra={
                            fields.length > 1 ? (
                              <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => remove(name)}
                              >
                                O'chirish
                              </Button>
                            ) : null
                          }
                        >
                          <Form.Item
                            {...restField}
                            label="Topshiriq nomi"
                            name={[name, "title"]}
                            rules={[
                              { required: true, message: "Topshiriq nomini kiriting!" },
                            ]}
                          >
                            <Input placeholder="Masalan: Hisobot tayyorlash" />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            label="Tavsif"
                            name={[name, "description"]}
                          >
                            <TextArea
                              rows={3}
                              placeholder="Topshiriq haqida qo'shimcha ma'lumot"
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            label="Foydalanuvchilar"
                            name={[name, "user_ids"]}
                            rules={[
                              {
                                required: true,
                                message: "Kamida bitta foydalanuvchi tanlang!",
                              },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="Foydalanuvchilarni tanlang"
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={users.map((user) => ({
                                value: user.id,
                                label: user.name || `${user.first_name} ${user.surname}`,
                              }))}
                            />
                          </Form.Item>
                        </AntCard>
                      ))}

                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() =>
                            add({ title: "", description: "", user_ids: [] })
                          }
                          block
                          icon={<PlusOutlined />}
                        >
                          Topshiriq qo'shish
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>

                <Divider />

                {/* Submit */}
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    icon={<EditOutlined />}
                  >
                    Saqlash
                  </Button>
                  <Button onClick={() => navigate(`/events/detail/${id}`)}>
                    Bekor qilish
                  </Button>
                </Space>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EventEdit;
